export const ES = {
  preparing_zip: "Preparando el zip…",
  compressing: "Comprimiendo…",
  info_icon: "Una vez marcado como completado, no se podrán unir ni agregar miembros adicionales, y todos los grupos de chat se desactivarán. Tenga en cuenta que el proyecto, junto con todos los grupos de chat y datos, permanecerá accesible en un estado desactivado.",
  mark_is_done: "¿Está seguro de que desea marcar el proyecto como completado? Una vez marcado, no se podrán unir ni agregar miembros adicionales, y todos los grupos de chat se desactivarán. Tenga en cuenta que el proyecto, junto con todos los grupos de chat y datos, permanecerá accesible en un estado desactivado.",
  mark_not_done: "¿Está seguro de que desea reabrir el proyecto? Una vez marcado como abierto, los miembros adicionales podrán unirse o ser agregados, y todos los grupos de chat se reactivarán.",
  mark_as_completed: "Marcar proyecto como completado",
  room_completed: "Proyecto completado",
  room_members: "Miembros del proyecto",
  deactivated_rooms: "Proyectos desactivados",
  deactivated_chats: "Chats desactivados",
  completed_rooms: "Proyectos completados",
  request_to_join_a_room: 'Solicitar unirse al proyecto',
  wants_to_rejoin_room: 'Username quiere volver a unirse al proyecto Roomname.',
  invited_you_to_join_room: 'Username te invitó a unirte al proyecto Roomname.',
  restart: "Reiniciar",
  update_text: "Hay una nueva actualización disponible. Haga clic en reiniciar para instalar la actualización.",
  update_availble: "Actualización disponible",
  Loading: "Cargando...",
  logout: "Cerrar sesión",
  back: 'Atrás',
  company_list: "Lista de empresas",
  followers: "Seguidores",
  followings: "Siguiendo",
  article: "Artículo",
  companies: "Empresas",
  one_to_one_chat: " Chat uno a uno",
  profile: "Perfil",
  company: "Empresa",
  company_selection: "Selección de empresa",
  home: "Inicio",
  contact: "Contacto ",
  add_company: "Agregar empresa ",
  add_project: "Agregar proyecto ",
  capacities: "Capacidades ",
  work_area: "Área de trabajo",
  company_services: "Servicios de la empresa",
  website: "Sitio web",
  search_contacts: "Buscar contactos",
  add_or_join_a_company: "Agregar o unirse a una empresa",
  follow: "Seguir",
  following: "Siguiendo",
  like: "Me gusta",
  company_contacts: "Contacto de la empresa",
  leave_the_company: "Dejar la empresa",
  news: "Noticias",
  earlier: "Anterior",
  action: "Acción",
  another_action: "Otra acción",
  something_else: "Algo más",
  search: "Buscar",
  search_rooms: "Buscar proyectos",
  search_articles: "Buscar artículos",
  contacts: "Contactos",
  suggestions: "Sugerencias",
  project_list: "Lista de proyectos",
  search_results: "Resultados de búsqueda",
  add_or_join_project: "Agregar o unirse al proyecto",
  details: "Detalles",
  your_position_within_company:
    "Por favor, elija su posición dentro de la empresa.",
  close_modal: "Cerrar",
  map: "Mapa",
  or: "O",
  name: "Nombre*",
  street: "Calle*",
  house_number: "Número de casa",
  postal_code: "Código postal",
  city: "Ciudad*",
  opened_by: "Abierto por:",
  project_No: "Número de proyecto: ",
  building_type: "Tipo de construcción*",
  building_types: "Tipo de construcción",
  add_join: "Agregar/Unirse",
  mandatory_fiels: "*campos obligatorios",
  invalid_fiels: "Este campo es obligatorio",
  add_or_join_company: "Agregar o unirse a la empresa",
  name_of_the_company: "Nombre de la empresa",
  edit_company_details: "Editar detalles de la empresa",
  branch_of_the_building_industry: "Rama de la industria de la construcción",
  corporate_form: "Forma corporativa",
  position_within_company: "Posición dentro de la empresa",
  request_confirmation: "Solicitudes de proyecto pendientes",
  company_e_mail: "Correo electrónico de la empresa",
  type_of_filter: "Escriba para filtrar...",
  setting: "Configuración",
  dashboard: "Panel",
  settings: "Configuración",
  views: "Vistas",
  times_seen: "veces visto",
  see_more: "...más",
  see_less: "...menos",
  in_search: "en búsqueda",
  reset_password: "Restablecer contraseña",
  submit: "Enviar",
  password: "Contraseña",
  email: "Correo electrónico",
  confirm_password: "Confirmar contraseña",
  reset_email: "Restablecer correo electrónico",
  update: "Actualizar",
  new_email: "Nuevo correo electrónico",
  kjuup_message: "Mensaje Kjuup",
  delete_profile: "¿Eliminar perfil?",
  my_position: "Mi posición:",
  add: "agregar",
  owner_company_admin: "Administrador de la empresa :",
  owner_company_admin_new: "Administrador de la empresa",
  mutual_contact: "contacto mutuo",
  mutual_contacts: "contactos mutuos",
  co_owner: "Copropietario",
  managing_director: "Director general",
  associate: "Asociado",
  secretary: "Secretario",
  employee: "Empleado",
  project_manage: "Gerente de proyecto",
  auto_chat_translation: "Traducción automática de chat",
  translate_room_group_names: "Traducir nombres de grupos de chat",
  translate_room_group_names_info: "Al activarlo, los nombres de los grupos de chat se traducen automáticamente a tu idioma de interfaz.",
  default_view_email: "Vista predeterminada: E-Mail",
  default_view_email_info: "Cuando está activado, la pestaña de E-Mail se abrirá por defecto en lugar de Mensajes al abrir la aplicación.",
  integrate_email_in_messages: "Integrate E-Mail in Messages",
  integrate_email_in_messages_info: "When enabled, emails from all connected accounts will appear alongside your chat messages, sorted by date.",
  language: "Idioma",
  english: "Inglés",
  german: "Alemán",
  french: "Francés",
  italian: "Italiano",
  change_language: "Cambiar idioma",
  my_companies: "Mis empresas",
  employees: "Empleados",
  invite_with_a: "Invitar a Kjuup",
  add_member: "Agregar miembro",
  add_user: "Agregar usuario",
  send_location: "Enviar ubicación",
  assign_admin_rights: "Ajustar derecho de administrador",
  deactivate_company: "Desactivar empresa",
  remove_employees: "Eliminar empleados",
  remove_members: "Eliminar miembros",
  no_user_found: "¡No se encontró usuario!",
  approve: "¡Aprobar!",
  deselect_all: "Deseleccionar todo",
  select_all: "Seleccionar todo",
  translation_on_building_projects: "Traducción en proyectos",
  reported_capacities: "Servicios reportados",
  up_to_50m_exact: "Hasta 50m exacto",
  company_details_service: "Servicios de la empresa",
  company_contact: "Contacto de la empresa",
  invite_with_link: "Invitar a Kjuup",
  share_link: "Compartir enlace",
  share_company_link: "Compartir enlace",
  qr_code: "Código QR",
  copy_link: "Copiar enlace",
  cancel_link: "Cancelar enlace",
  who_has_confirmed_services: "¿Quién ha confirmado sus servicios?",
  projectss: "Proyectos",
  add_services: "Agregar servicios",
  services: "Servicios",
  save_text: "Guardar",
  share_on: "Compartir en:",
  articlen: "Artículo",
  invite_user_to_confirm_service:
    "Invite a usuarios a confirmar servicios a la empresa.",
  link_copied: "¡Enlace copiado!",
  email_copied: "¡Correo electrónico copiado!",
  personal_article: "Artículo personal",
  company_article: "Artículo de la empresa",
  characters_remaining: "Caracteres restantes",
  optional_information: "Información opcional",
  project: "Proyecto",
  projects: "Proyectos...",
  abort: "Descartar",
  preview: "Vista previa",
  post: "Publicar",
  of: "de",
  remove: "Eliminar",
  free_capacity: "Portal de empleo",
  current_status_overview: "Resumen del estado actual",
  report_capacities: "Reportar servicios",
  report_text: "Reportar",
  search_capacities: "Buscar contratistas",
  add_project_user: "Agregar usuario del proyecto",
  media: "Medios",
  links: "Enlaces",
  docs: "Documentos",
  featured_products: "Productos destacados...",
  title: "Título",
  text: "Texto",
  feed_details: "Detalles del feed",
  add_employee: "Agregar empleado",
  latest: "Más reciente",
  my_projects: "Mis proyectos",
  cancel: "Cancelar",
  continue: "Continuar",
  role_in_the_building_industry: "Rol en la industria de la construcción",
  als: "como",
  join: "unirse",
  find: "Buscar",
  request_to_join_a_company: "Solicitar unirse a la empresa",
  wants_to_join_the_company: "quiere unirse a la empresa",
  filter_by: "Filtrar por",
  ok: "Ok",
  close: "Cerrar",
  weekly_statistics: "Estadísticas semanales",
  is_following_you: "te está siguiendo.",
  as: "como",
  has_joined_the: "se ha unido a la empresa",
  has_looked_at_your_profile: "ha visto tu perfil.",
  time: "Hora",
  in_searches_in_past_week: "en búsquedas en la semana pasada.",
  has_liked_your_article: "le ha gustado tu artículo.",
  has_published_a_new_article: "ha publicado un nuevo artículo.",
  you: "Tú",
  all_views: "Todas las vistas",
  all_profile_views: "Todas las vistas del perfil",
  mutual_company: "empresa mutua",
  artical_text: "Escribir artículo...",
  you_have_appeared: "Has aparecido",
  your_request_at_the_company: "Tu solicitud en la empresa",
  times_you_have_appeared_in_searches: "veces que has aparecido en búsquedas",
  appear_more_often_in_searches: "Aparecer más a menudo en búsquedas",
  you_have_been_found: "Has sido encontrado",
  improve_profile: "Mejorar perfil",
  choose_existing_contact_for_single_chat:
    "Elegir contacto existente para chat individual:",
  in_order_to_add_new_contacts:
    "Para agregar nuevos contactos, busque nuevos contactos en la página de perfil.",
  times_in_searches_in_the_last_week:
    "veces en búsquedas en la última semana. Actualice su perfil y agregue más detalles para ser encontrado más fácilmente.",
  has_been_confirmed: "ha sido confirmado.",
  have_joined_the: "se han unido al  ",
  building_project: " proyecto de construcción.",
  select_with_which_company_you_want_to_connect_to_the_project:
    "Seleccione la empresa que representará. Esto se mostrará a otros participantes.",
  select_with_which_company_you_want_to_connect_to_the_chat:
    "Seleccione la empresa que representará. Esto se mostrará a otros participantes.",
  select_internal_section: "Por favor, seleccione sección interna",
  select_profile_image: "Seleccionar imagen de perfil",
  share_user: "Compartir usuario",
  contact_sender_message:
    "Comparta este enlace para invitar a un no miembro de Kjuup a Kjuup. Este enlace puede ser usado por múltiples personas para registrarse.",
  project_sender_message:
    "Comparta este enlace para invitar a un no miembro de Kjuup al proyecto nombre del proyecto. Este enlace puede ser usado por múltiples personas para registrarse y unirse al proyecto nombre del proyecto en Kjuup.",
  company_sender_message:
    "Comparta este enlace para invitar a un no miembro de Kjuup a la empresa nombre de la empresa. Este enlace puede ser usado por múltiples personas para registrarse y unirse a la empresa en Kjuup.",
  contact_receivers_message:
    "Enlace de invitación para unirse a Kjuup. Por favor, haga clic en el enlace para registrarse en kjuup.",
  iphone: "iPhone:",
  iphone_recivers_message:
    "En caso de que esté instalando Kjuup a través de Apple App Store, debe hacer clic en este enlace después de la descarga exitosa, para poder registrarse.",
  project_receivers_message:
    "Enlace de invitación para unirse al proyecto nombre del proyecto en Kjuup. Por favor, haga clic en el enlace para registrarse en Kjuup y unirse al proyecto nombre del proyecto.",
  company_receivers_message:
    "Enlace de invitación a la empresa nombre de la empresa en Kjuup. Por favor, haga clic en el enlace para registrarse en Kjuup y unirse a la empresa nombre de la empresa.",
  sign_in: "Iniciar sesión",
  enter_your_email_add: "Ingrese su dirección de correo electrónico",
  forgot_password: "¿Olvidó su contraseña?",
  dont_have_account: "¿No tiene una cuenta?",
  register: "Registrarse",
  get_app: "Obtener la aplicación",
  registration: "Registro",
  dep_ing: "Dipl.-Ing.",
  dr: "Dr.",
  dr_ing: "Dr.-Ing.",
  dep_ing_arc: "Dipl.-Ing. Arquitecto",
  prof: "Prof.",
  first_name: "Nombre",
  last_name: "Apellido",
  have_an_account: "¿Tiene una cuenta?",
  when_register_you_agree: "Al registrarse, acepta nuestros",
  term_of_use: "términos de uso",
  to: "a.",
  in_our: "En nuestra",
  data_policy: "políticas de datos",
  they_find_out: "se enteran,",
  we_provide_store_data: "cómo recopilamos, procesamos y almacenamos información.",
  leaving_company_text:
    "¿Realmente desea dejar la empresa? Al dejar la empresa, también deja todos los proyectos y grupos de chat asociados. Puede volver a unirse a estos proyectos con otra empresa en cualquier momento.",
  delete_profile_text:
    "¿Realmente desea eliminar su perfil? Cuando elimine su perfil, se eliminarán todas las conexiones con empresas, proyectos y chats. Puede crear un nuevo perfil en cualquier momento.",
  confirm: "Confirmar",
  reject: "Rechazar",
  requet_to_leave: "Solicitar salir",
  choose: "Elegir",
  your_add_member: "Agregar miembro",
  if_you: "en caso de que",
  can_not_find: "no pueda encontrar su contacto aquí.",
  please_wait: "Por favor espere..",
  imprint_gtc: "Impreso/Términos y condiciones",
  register_confirm_popup: "Verifique su dirección de correo de Kjuup antes de iniciar sesión. Le hemos enviado un enlace de confirmación. Si no lo ve, revise también la carpeta de spam.",
  PENDING_GROUP_USER:
    "recibirá mensajes solo después de que se confirme la invitación al proyecto. Aparecerá un mensaje adicional una vez que se confirme la invitación al proyecto.",
  PENDING: "Confirmación de invitación al proyecto pendiente",
  denied_group_chat: " ha denegado la invitación al proyecto y ha dejado este grupo.",
  // joined_group_chat: " se ha unido a la sala y este grupo.",
  joined_group_chat: " se unió a este grupo",
  you_joined_group_chat: "Te uniste a este grupo.",
  Others: "Otros",
  LEFT_GROUP: "ha dejado este grupo de chat.",
  YOU_LEFT_GROUP: "han dejado este grupo de chat.",
  days: "días",
  day: "día",
  hour: "hora",
  hide_project: "Ocultar proyecto",
  hide_project_popup_text:
    "Si oculta proyectos, no se pueden encontrar dentro de Kjuup. Solo los miembros del proyecto pueden invitar nuevos usuarios al proyecto.",
  branch: "Rama",
  photo_video_media_lib: "Biblioteca de medios - Foto y video",
  document: "Documento",
  location_meeting: "Ubicación / Reunión",
  all_member_of_project: "Todos los miembros del proyecto",
  pending_request: "Solicitudes de proyecto pendientes",
  no_pending_request: "¡No se encontraron solicitudes pendientes!",
  news_feed: "Feed de noticias",
  user_info: "Información del grupo",
  leave_project: "Dejar proyecto",
  media_link_docs: "Archivos",
  search_chat: "Buscar chat",
  export_chat_group: "Exportar datos del grupo de chat del último mes",
  request_complete_chat_history: "Solicitar historial completo de chat",
  leave_chat_group: "Dejar grupo de chat",
  add_user_project: "Agregar usuario",
  me: "Yo",
  max_open_one_to_one:
    "Actualmente se pueden abrir máx. 2 chats uno a uno en paralelo en la sección inferior y superior. En total, máx. 4 chats uno a uno son posibles.",
  are_you_sure_you_want_leave_chat:
    "¿Está seguro de que desea dejar este grupo de chat?",
  create_group: "Crear grupo",
  adding_members: "Añadiendo miembros...",
  creating_the_chat: "Creando el chat...",
  finishing_setup: "Finalizando...",
  group_name: "Nombre del grupo",
  by: "Por:",
  mandetory: "*obligatorio",
  delteed: "ha eliminado su perfil y ha dejado el chat grupal.",
  deleted_direct: "ha eliminado su perfil y ha dejado el chat.",
  unhidden_message:
    "Si muestra proyectos, pueden ser encontrados por todos los miembros de Kjuup.",
  account_deleted: "La cuenta ha sido eliminada.",
  refuse_company: "¿Está seguro de que desea rechazar la invitación de la empresa?",
  follow_additional: "Seguir usuarios adicionales",
  f_add:
    "Siga usuarios adicionales de Kjuup para hacerlos disponibles para mensajes directos.",
  c_inv: "Invitación(es) de empresa",
  invited_o_Company: "Has sido invitado a unirte a la empresa",
  refuse_companyX: "¿Está seguro de que desea rechazar la solicitud de la empresa?",
  a_Da: "Cuenta desactivada.",
  has_deactivated: "ha desactivado su perfil.",
  reactive: "ha reactivado su perfil.",
  juup_note: "*El registro con nombre de usuario solo está disponible para miembros de Kjuup+",
  username: "Nombre de usuario*",
  email_username: "Correo electrónico/Nombre de usuario*",
  sPinText:
    "Por favor, proporcione un PIN de seguridad de 6 dígitos. Este PIN será necesario en caso de que olvide su contraseña y es obligatorio para confirmar su cuenta.",
  DeleteKjuupPlusText:
    "¿Realmente desea eliminar su perfil? Cuando elimine su perfil, se eliminarán todas las conexiones con empresas, proyectos y chats.\n\nDentro de 48 horas después de la eliminación de la cuenta, puede reactivar su cuenta iniciando sesión con nombre de usuario, contraseña y PIN.",
  reactive_text:
    "Su cuenta ha sido eliminada. Por favor, haga clic en Reactivar para reactivar su cuenta.",
  rac: "Reactivar",
  ac_ss: "Cuenta reactivada exitosamente.",
  not_valid_pin: "PIN inválido",
  only_for_kjuup:
    "*El restablecimiento de contraseña mediante nombre de usuario y PIN solo está disponible para miembros de Kjuup+.",
  resetPIN: "Restablecer PIN",
  enter_current_pin: "Por favor, ingrese su PIN actual",
  enter_new: "Ingrese nuevo PIN",
  pin_to_confirm: "Por favor, proporcione el PIN para confirmar.",
  change_username: "Restablecer nombre de usuario",
  pp_not_match: "La contraseña y la confirmación de contraseña no coinciden",
  reactive_itself: "Has reactivado tu perfil.",
  has_deactivated_itself: "Has desactivado tu perfil.",
  more_than_two:
    "Actualmente los mensajes directos solo se pueden hacer con 2 usuarios en paralelo.",
  Chats: "Mensajes directos",
  only_in_mobileL:
    "Los videos nativos actualmente solo se pueden subir y publicar a través de la aplicación móvil. Por favor, use enlaces de video de Youtube y Vimeo.",
  register_pin_text:
    "Por favor, elija su PIN personal de 6 dígitos. Este PIN será necesario para habilitar las funcionalidades de restablecimiento de cuenta.",
  internal_project: "Interno",
  external_projects: "Externo",
  in_deacticted: "La sección interna está desactivada.",
  create_article: "Crear artículo",
  new_article_selection: "Crear artículo para feed de noticias externo",
  new_article_selection_internal: "Crear artículo interno",
  active_trans_title: "¿Activar la traducción automática?",
  active_trans: "Cuando esté activada, todos los mensajes de chat entrantes se traducirán al idioma de la aplicación que haya seleccionado.",
  disable_trans: "¿Realmente desea desactivar la traducción automática?",
  allow_access_chat: "Mostrar historial completo de chat",
  toggle_chat_history_on:
    "¿Realmente desea que el usuario vea el historial completo de chat?",
  toggle_chat_history_off:
    "¿Realmente desea que el usuario solo vea el historial de chat desde el punto de unirse al chat?",
  check_selected_settings:
    "¡Por favor, verifique la configuración del historial de chat para todos los usuarios seleccionados!",
  chat_from_start_have:
    "Te has unido a este grupo. El historial de chat ha sido compartido.",
  chat_from_start_has:
    "se ha unido a este grupo. El historial de chat ha sido compartido.",
  Address: "Dirección",
  read_by: "Leído por",
  deliver_to: "Entregado a",
  remaining: "restante",
  message_info: "Información del mensaje",
  request_to_join_only: "Solicitar unirse",
  unfollow: "Dejar de seguir",
  company_username: "Nombre de usuario",
  month: [
    "Ene",
    "Feb",
    "Mar",
    "Abr",
    "May",
    "Jun",
    "Jul",
    "Ago",
    "Sep",
    "Oct",
    "Nov",
    "Dic",
  ],
  remove_my_admin_right: "Eliminar mis derechos de administrador",
  makeEmp: "¿Realmente desea eliminar los derechos de administrador de la empresa del usuario?",
  remove_my_self:
    "¿Realmente desea eliminar los derechos de administrador de la empresa de su cuenta?",
  makeAdmin: "¿Realmente desea dar al usuario derechos de administrador de la empresa?",
  remove_member: "Eliminar miembro",
  remove_following_confirm: "¿Realmente desea eliminar a {name} de la lista de seguidos?",
  remove_follower_confirm: "¿Realmente desea eliminar a {name} de sus seguidores? Si lo elimina, no será informado/a.",
  do_you_really_want_to_remove:
    "¿Realmente desea eliminar el nombre de usuario de la empresa?",
  invite_all: "Invitar a todos los miembros de la empresa",
  invite_all_members: "Invitar a todos los miembros",
  mems: "Todos los demás miembros",
  dep_loc: "Departamento/Ubicación/Equipo",
  depAdmin: "Administrador de departamento",
  add_remove_admin: "Agregar/Eliminar posición de administrador de empresa",
  add_remove_dep_admin: "Agregar/Eliminar posición de administrador de departamento",
  remove_employees_dept: "Eliminar empleados de",
  want_to_join_dep:
    "Nombre de usuario quiere unirse al Departamento/Ubicación/Equipo depname de la empresa companyname.",
  you_invited:
    "Has sido invitado a unirte al Departamento/Ubicación/Equipo depname de la empresa companyname.",
  dep_remove:
    "¿Realmente desea eliminar los derechos de administrador de departamento o ubicación del usuario?",
  add_dep:
    "¿Realmente desea dar al usuario derechos de administrador para el departamento o ubicación?",
  my_self_dep_remove:
    "¿Realmente desea eliminar los derechos de administrador de departamento de su cuenta?",
  member: "Miembro",
  admin: "Administrador",
  remove_project_admin:
    "¿Realmente desea eliminar al miembro del proyecto?",
  remove_my_self_project: "¿Realmente desea eliminar los derechos de administrador?",
  remove_member_admin_right:
    "¿Realmente desea eliminar los derechos de administrador del usuario?",
  add_member_admin_right: "¿Realmente desea agregar derechos de administrador al usuario?",
  add_remove_Poss: "Agregar/Eliminar posición de administrador",
  forward: "Reenviar",
  forward_to: "Reenviar a...",
  edit: "Editar",
  only_kjuup_plus_can: "Solo las empresas Kjuup+ pueden publicar artículos.",
  add_images: "Agregar imagen(es)",
  request_confirmation: 'Invitaciones de proyecto pendientes',
  Activity: "Actividad",
  latest_messages: "Mensajes más recientes",
  hours: "horas",
  minute: "minutos",
  seconds: "segundos",
  days: "días",
  yesterday: "ayer",
  last_week: "la semana pasada",
  next_week: "la próxima semana",
  Last_month: "el mes pasado",
  All: "Todo",
  register_plus: "Registro Plus",
  select_files: "Seleccionar archivos",
  monthsFullName: [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
  ],
  company_deploc_receivers_message:
    "Enlace de invitación al departamento de la empresa nombre de la empresa en Kjuup. Por favor, haga clic en el enlace para registrarse en Kjuup y unirse a la empresa nombre de la empresa.",
  no_news: "No hay noticias disponibles",
  reminder: "Recordatorio",
  np_reminder: "Sin tareas pendientes",
  move_to_reminder: "Mover a tarea pendiente",
  remove_reminder: "¿Realmente desea eliminar este mensaje de la lista de sus tareas pendientes?",
  remove_all_reminder: "Eliminar todas las tareas pendientes",
  remove_all_confirm: "¿Realmente desea eliminar todos los mensajes de la lista de sus tareas pendientes?",
  remove_from_reminder: "Eliminar del recordatorio",
  prevent_email: "El correo electrónico no puede ser usado como nombre de usuario.",
  allow_noti: "Por favor, permita las notificaciones.",
  join_cap: "Unirse",
  pass_minimum:
    "**La contraseña requiere 12 caracteres incl. letra minúscula, mayúscula, número y carácter especial.",
  pass_error: "Por favor, verifique los requisitos de contraseña",
  people_that_like_article: "Personas a las que les gusta el artículo.",
  people_who_like_article: "Personas a las que les gusta tu artículo.",
  message_delete: "Este mensaje ha sido eliminado.",
  message_edited: "editado",
  edit_message: "Editar mensaje",
  edit_window_expired: "Los mensajes solo se pueden editar dentro de los 10 minutos posteriores al envío.",
  message_edit_save: "Guardar",
  copy: "Copiar",
  bookmark: "Marcador",
  add_reaction: "Añadir reacción",
  delete_message: "Eliminar mensaje",
  more_options: "Más opciones",
  info: "Info",
  delete_message_confirm: "¿Realmente quieres eliminar este mensaje?",
  link_invite: "Invitar mediante enlace",
  ll_nkk: "Invitar a Kjuup",
  selected: "Seleccionado",
  is_active: "Activo",
  inactive: "Inactivo",
  last_online: "última vez en línea {{when}}",
  remove_user_l: "Eliminar",
  link_expire: "Cada enlace generado será válido por 72 horas.",
  company_language: "Idioma de la empresa",
  company_language_info:
    "La selección de idioma se usará para todas las confirmaciones por correo electrónico relacionadas con la empresa.",
  s_image: "imagen",
  m_image: "imágenes",
  removeMsg: "Tocar para eliminar",
  block: 'Bloquear',
  unblock: 'Desbloquear',
  blocks: '¿Está seguro de que desea bloquear a este usuario?',
  unblocks: '¿Está seguro de que desea desbloquear a este usuario?',
  bolcked_click_un_block:
    'Has bloqueado este contacto. Haga clic aquí para eliminar el bloqueo.',
  you_have_unblocked: 'Has desbloqueado este contacto.',
  you_have_blocked: 'Has bloqueado este contacto.',
  unblock_to_send: 'Desbloquear usuario para enviar mensaje.',
  pilot_text: "IA especializada para temas de construcción",
  startup_screen_label: "Pantalla de inicio",
  startup_screen_info: "Elige qué pantalla se abre al iniciar Kjuup.",
  startup_screen_feed: "Home",
  startup_screen_messages: "Mensajes",
  startup_screen_saved: "Pantalla de inicio actualizada",
email_on: "Notificaciones por correo electrónico de chats",
  email_on_grp: "Notificación por correo electrónico",
  article_email_on: "Notificaciones por correo de artículos",
  article_email_info: "Si habilitas las notificaciones por correo para artículos internos, recibirás un correo cuando se publique un nuevo artículo interno en tu empresa y departamento.",
  info_email_room: "Active o desactive las notificaciones por correo electrónico para este proyecto. Esta opción solo está disponible cuando \"Notificaciones por correo electrónico de chats\" está habilitada a través de la configuración personal.",
  todo_notification_info: "Recibirás una notificación cada vez que se te asigne una nueva tarea.",
  info_val: "Recibirás un correo electrónico si un mensaje de chat nuevo no se lee en poco tiempo. Puedes desactivarlo para proyectos o chats concretos en sus ajustes o en la información del grupo de chat.",
  email_groups: "Active o desactive las notificaciones por correo electrónico para este chat. Esta opción solo está disponible cuando \"Notificaciones por correo electrónico de chats\" está habilitada a través de la configuración personal y del proyecto.",
  add_update_email: "Agregar/Actualizar correo electrónico",
  text_to_verifiy: "La opción \"Notificaciones por correo electrónico de chats\" solo se puede habilitar si tiene una dirección de correo electrónico verificada en archivo.",
  stored_email: "Correo electrónico almacenado: ",
  verify_email: "¡Confirmación pendiente!",
  join_call:"Unirse",
  call_is_started:"Llamada iniciada",
  start_chat:"¿Iniciar chat directo?",
  project_rooms:"Proyectos",
  download_selected:"Descargar",
  add_employee_confirm: '¿Está seguro de que desea agregar este usuario a la empresa?',
  invalid_deeplink: "URL de enlace profundo inválida. Faltan parámetros requeridos.",
  deeplink_error: "No se puede procesar el enlace profundo. Por favor, intente nuevamente más tarde.",
  // Reply functionality translations
  reply: "Responder",
  reply_enter: "Ingrese respuesta...",
  reply_sent_successfully: "Respuesta enviada exitosamente",
  reply_failed: "Error al enviar respuesta",
  reply_failed_generic: "Error al enviar respuesta. Por favor, intente nuevamente.",
  replying_to_message: "Respondiendo al mensaje",
  cancel_reply: "Cancelar respuesta",
  voice_message: "Mensaje de voz",
  send: "Enviar",
  cancel: "Cancelar",
  type_your_reply: "Escriba su respuesta...",
  
  // Auto-suggestion translations
  suggested_replies: "Respuestas sugeridas",
  suggestions_error: "Error al cargar sugerencias",
  positive_suggestion_placeholder: "Positive",
  neutral_suggestion_placeholder: "Neutral",
  negative_suggestion_placeholder: "Negative",
  lazy_media_image: "Imagen — Clic para cargar",
  lazy_media_audio: "Mensaje de voz — Clic para cargar",
  lazy_media_doc: "Documento — Clic para cargar",
  lazy_media_video: "Vídeo — Clic para cargar",
  suggestion_loading_message: "Un momento. Su texto está siendo preparado individualmente para usted.",
  loading_chat_message: "Cargando chat...",
  
  // Manual ToDo translations
  extracting_message: "Extrayendo mensaje...",
  create_todo: "Crear tarea pendiente",
  create_todo_confirmation: "¿Desea crear una tarea pendiente a partir de este mensaje?",
  select_project_required: "Por favor, seleccione un proyecto/grupo",
  only_assigned_can_change_status: "Solo los usuarios asignados pueden cambiar el estado",
  todo_summary: "Resumen",
  todo_summary_placeholder: "Ingrese resumen de tarea pendiente...",
  todo_date: "Fecha",
  todo_time: "Hora",
  deadline: "Fecha límite",
  todo_date_hint: "Deje vacío para usar la fecha/hora del mensaje original",
  todo_created_success: "Tarea pendiente creada exitosamente",
  todo_creation_failed: "Error al crear tarea pendiente",
  create: "Crear",
  
  image: "imagen",
  images: "imágenes",
  remove_all_images: "Eliminar todas las imágenes",
  remove_image: "Eliminar imagen",
  remove_document: "Eliminar documento",
  remove_recording: "Eliminar grabación",
  play_recording: "Reproducir grabación",
  upload_image: "Subir imagen",
  upload_document: "Subir documento",
  record_audio: "Grabar audio",
  stop_recording: "Detener grabación",
  stop_recording_text: "Detener grabación",
  please_remove_current_attachment: "Por favor, elimine el archivo adjunto actual para",
  please_upload_image_file: "Por favor, suba un archivo de imagen válido",
  please_upload_valid_document: "Por favor, suba un archivo de documento válido",
  searching_messages: "Buscando mensajes...",
  loading_more: "Cargando más...",
  loading_more_users: "Cargando más usuarios...",
  load_more_users: "Cargar más usuarios",
  no_more_users_to_load: "No hay más usuarios para cargar",
  no_messages_found: "No se encontraron mensajes",
  try_different_keyword: "Intente una palabra clave diferente o verifique su ortografía.",
  search_messages: "Buscar mensajes, grupos de chat, proyectos y usuarios...",
  search_groups: "Grupos",
  search_chat_groups: "Grupos de chat",
  search_project_room: "Proyecto",
  search_messages_tab: "Mensajes",
  searching_groups: "Buscando grupos...",
  searching_rooms: "Buscando proyectos...",
  no_groups_found: "No se encontraron grupos",
  no_rooms_found: "No se encontraron proyectos",
  search_users_tab: "Usuarios",
  search_documents_tab: "Documentos",
  company_documents: "Company documents",
  company_documents_empty: "No documents available.",
  no_media_available: "Sin archivos",
  no_documents_available: "No documents",
  searching_users: "Buscando usuarios...",
  no_users_found: "No se encontraron usuarios",
  search_emails_tab: "Correo",
  searching_emails: "Buscando correos...",
  no_emails_found: "No se encontraron correos",
  search_email_addresses_tab: "E-Mail Addresses",
  search_email_content_tab: "E-Mail Content",
  searching_email_content: "Searching email content...",
  no_email_content_found: "No email content found",
  search_email_attachments_tab: "E-Mail Attachments",
  searching_email_attachments: "Searching attachments...",
  no_email_attachments_found: "No attachment matches found",
  email_attachments_label: "Attachments",  searching_email_addresses: "Searching addresses...",
  no_email_addresses_found: "No address matches found",
  email_subject_label: "Subject",
  email_body_label: "Body",
  email_address_received: "Received",
  email_address_sent: "Sent",
  todo: "Tarea pendiente",
  np_todo: "Sin tareas pendientes",
  move_to_todo: "Guardar como tarea pendiente",
  remove_todo: "¿Realmente desea eliminar la tarea pendiente?",
  remove_all_todo: "Eliminar todas las tareas pendientes",
  remove_all_todo_confirm: "¿Realmente desea eliminar todas las tareas pendientes?",
  add_to_todo: "Añadir a tarea pendiente",
  remove_from_todo: "Eliminar de tarea pendiente",
  confirm: "Confirmar",
  ok: "Ok",
  read_more: "Leer más",
  show_less: "Mostrar menos",
  show_more: "Mostrar más",
  audio: "Audio",
  video: "Video",
  // Notification Settings
  notification_schedule: "Programa de notificaciones",
  notification_schedule_desc: "Solo recibirá notificaciones push y por correo electrónico en las horas que elija. Fuera de esos horarios, se pausarán.",
  learn_more: "Aprender más",
  allow_notifications: "Permitir notificaciones:",
  every_day: "Todos los días",
  weekdays: "Días laborables (lunes a viernes)",
  custom: "Personalizado",
  monday: "Lunes",
  tuesday: "Martes",
  wednesday: "Miércoles",
  thursday: "Jueves",
  friday: "Viernes",
  saturday: "Sábado",
  sunday: "Domingo",
  to: "a",
  notification_settings: "Notificaciones",
  notification_settings_saved: "Configuración de notificaciones guardada exitosamente",
  notification_settings_error: "Error al guardar la configuración de notificaciones",
  unavailability_note: "Nota de ausencia",
  unavailability_description: "Configure una nota de ausencia. Mientras esté activa, la nota se muestra a los demás en todos sus chats y las notificaciones se pausan.",
  unavailability_start_date: "Fecha de inicio",
  unavailability_end_date: "Fecha de fin",
  unavailability_message: "Mensaje",
  unavailability_message_hint: "Use {endDate} como marcador de posición para su fecha de regreso.",
  unavailability_replacement: "Contacto de reemplazo",
  unavailability_replacement_placeholder: "Ingrese el ID de usuario para solicitudes urgentes",
  unavailability_replacement_current: "Reemplazo actual",
  unavailability_replacement_hint: "Si se establece, se mostrará un enlace para contactar a esta persona para asuntos urgentes en su nota de ausencia.",
  unavailability_replacement_none: "Sin reemplazo (opcional)",
  unavailability_contact_urgent: "Para solicitudes urgentes contacte a",
  unavailability_default_message: "Actualmente no estoy en la oficina y no tengo acceso a Kjuup. Estaré disponible de nuevo a partir del {endDate} y me pondré en contacto con usted entonces.",
  unavailability_save: "Guardar",
  unavailability_deactivate: "Desactivar",
  unavailability_active_until: "Activo hasta",
  unavailability_saved: "Nota de ausencia guardada",
  unavailability_save_error: "Error al guardar la nota de ausencia",
  unavailability_deactivated: "Nota de ausencia desactivada",
  unavailability_end_date_required: "La fecha de fin es obligatoria",
  start_time_before_end_time: "La hora de inicio debe ser antes de la hora de finalización",
  loading: "Cargando",
  disabled: "Deshabilitado",
  enable: "Habilitar",
  disable: "Deshabilitar",
  forwarded: "Reenviado",
  message_forwarded: "¡Mensaje reenviado!",
  // Schedule Article
  schedule_article_post: "Programar publicación de artículo",
  date: "Fecha",
  time: "Hora",
  scheduled_for_publication: "Programado para publicación",
  article_will_be_published_on: "El artículo se publicará el:",
  reset_selection: "Restablecer selección",
  continue: "Continuar",
  cancel: "Cancelar",
  // Member Selection
  error_loading_members: "Error al cargar miembros",
  please_fill_all_fields: "Por favor, complete todos los campos",
  invalid_email: "Dirección de correo electrónico inválida",
  member_added_successfully: "Miembro agregado exitosamente",
  error_onboarding_user: "Error al agregar usuario",
  error_creating_chat: "Error al crear chat",
  error_creating_group: "Error al crear grupo",
  new_group: "Nuevo grupo",
  please_select_or_enter_group_name: "Por favor, seleccione un grupo o ingrese un nombre de grupo",
  please_select_or_enter_room_name: "Por favor, seleccione un proyecto o ingrese un nombre de proyecto",
  error_creating_room: "Error al crear proyecto",
  error_opening_chat: "Error al abrir chat",
  privacy_modal_text: "Seleccione \"Privado\" solo si el chat no contiene contenido profesional relevante para el gerente de proyecto.",
  not_private: "No privado",
  private: "Privado",
  error_loading_groups: "Error al cargar grupos",
  automatic_chat_export: "Exportación automática de chat",
  automatic_chat_export_info: "Después de la activación, el historial de chat se enviará automáticamente a la dirección de correo electrónico especificada cada mes.",
  automatic_chat_export_no_email: "Para activar la exportación automática de chat, primero debes agregar una dirección de correo electrónico. Puedes agregar tu dirección de correo electrónico en la configuración personal.",
  enter_email: "Ingrese correo electrónico",
  update: "Actualizar",
  confirm: "Confirmar",
  export_to_email: "La exportación va al siguiente correo electrónico.",
  start_chat_button:"Nuevo mensaje",
  matching_existing_chats: "Chats existentes coincidentes",
  subject: "Asunto",
  add_subject: "Agregar asunto",
  chat_subject: "Asunto del chat:",
  set_project_room: "Establecer proyecto",
  matching_existing_project_rooms: "Proyectos existentes coincidentes",
  name_project_room: "Nombrar proyecto",
  professional_or_private: "Profesional o privado",
  professional: "Profesional",
  privacy_modal_text_updated: "Solo seleccione \"Privado\" si el chat no contiene contenido profesional relevante para los gerentes de proyecto. Los chats privados no son visibles para los gerentes de proyecto.",
  create_internal_chat: "¿Chat externo o interno?",
  internal_chat_description: "Solo los empleados de su empresa pueden ser agregados a chats internos.",
  yes: "Sí",
  no: "No",
  chat_is_being_created: "El chat se está creando...",
  // Additional translations for hardcoded text
  discard_article_confirm: "¿Realmente desea descartar los cambios de este artículo?",
  please_enter_article_title: "Por favor, ingrese primero el título del artículo.",
  please_add_mandatory_fields: "Por favor, agregue todos los campos obligatorios",
  product_label: "Producto:",
  no_companies_found: "No se encontraron empresas",
  visible_to_all_followers: "Visible para todos los miembros de Kjuup",
  only_visible_to_employees: "Solo visible para empleados",
  something_went_wrong: "Algo salió mal, por favor intente nuevamente",
  please_select_department: "Por favor, seleccione departamento/ubicación",
  schedule: "Programar",
  please_select_future_date_time: "Por favor, seleccione una fecha y hora futuras para programar el artículo.",
  please_select_different_date_time: "Por favor, seleccione una fecha u hora diferente para programar el artículo.",
  please_select_later_time: "Por favor, seleccione una hora posterior a la hora actual para hoy.",
  unpin_article: "Desanclar artículo",
  pin_article: "Anclar artículo",
  and: "y",
  others: "otros",
  at: "en",
  // Chat mute/unmute translations
  mute: "Silenciar",
  unmute: "Activar sonido",
  chat_muted_successfully: "Chat silenciado exitosamente",
  chat_unmuted_successfully: "Sonido del chat activado exitosamente",
  mute_chat_confirm: "¿Realmente desea silenciar este chat? Ya no recibirá notificaciones para nuevos mensajes.",
  unmute_chat_confirm: "¿Realmente desea activar el sonido de este chat? Volverá a recibir notificaciones para nuevos mensajes.",
  please_select_group_to_forward: "Por favor, seleccione grupo para reenviar mensaje",
  // Company translations
  record_not_found: "¡Registro no encontrado!",
  please_select_position: "Por favor, seleccione posición",
  delete_article_confirm: "¿Está seguro de que desea eliminar este artículo?",
  delete_company_service_confirm: "¿Está seguro de que desea eliminar el servicio de la empresa?",
  block_translation_confirm: "¿Realmente desea bloquear la traducción automática en proyectos para todos los miembros de la empresa",
  unblock_translation_confirm: "¿Realmente desea desbloquear la traducción automática en proyectos para todos los miembros de la empresa",
  please_select_file: "Por favor, seleccione un archivo para subir",
  role_in_building_industry: "Rol en la industria de la construcción*",
  invalid_email_address: "Dirección de correo electrónico inválida",
  please_enter_password: "Por favor, ingrese contraseña",
  password_change_email_sent: "Se ha enviado un correo a su email de Kjuup. Confirme su nueva contraseña haciendo clic en el enlace de confirmación del correo.",
  please_enter_username: "Por favor, ingrese nombre de usuario",
  username_same_as_before: "El nombre de usuario no puede ser el mismo que antes",
  profile_deleted_successfully: "Perfil eliminado exitosamente",
  hardware_requirements: "Requisitos de hardware",
  hardware_requirements_list: "• 4GB RAM<br/>• Velocidad de CPU mín. 2GHz<br/>• Windows 7 o superior / todas las versiones de macOS",
  submitting: "Enviando...",
  signing_in: "Iniciando sesión...",
  please_enter_service_name: "Por favor, ingrese nombre del servicio",
  something_went_wrong_error: "¡Aaaah! Algo salió mal...",
  something_went_wrong_try_again: "Lo siento, algo salió mal. Intente nuevamente",
  position_label: "Posición:",
  loading_room: "Cargando proyecto...",
  navigating_to_room: "Navegando al proyecto",
  loading_chat: "Cargando chat...",
  translate: "Traducir",
  show_original: "Mostrar original",
  saving: "Guardando...",
  language_selection_info: "La selección de idioma se usa para todas las confirmaciones por correo electrónico relacionadas con la empresa.",
  // Navigation bar labels
  nav_call: "Llamar",
  nav_home: "Inicio",
  nav_messages: "Mensajes",
  nav_todo: "Tareas",
  nav_rooms: "Proyectos",
  nav_all_rooms: "Todos los proyectos",
  pinned_rooms_max: "Puedes fijar hasta 10 proyectos.",
  pinned_room_unpin: "Desanclar",
  pinned_rooms_drop: "Arrastra tu proyecto aquí para una selección rápida",
  nav_profile: "Perfil",
  nav_company: "Empresa",
  nav_company_documents: "Documentos",
  nav_logout: "Cerrar sesión",
  // Create message dialog
  add_member_title: "Agregar miembro",
  continue_btn: "Continuar",
  search_placeholder: "Buscar",
  no_members_found: "No se encontraron miembros",
  no_groups_found: "No se encontraron grupos",
  no_rooms_found: "No se encontraron proyectos",
  unnamed_group: "Grupo sin nombre",
  unnamed_room: "Proyecto sin nombre",
  all_members: "Todos",
  room_label: "Proyecto:",
  subject_label: "Asunto:",
  no_members: "Sin miembros",
  // Loading states for room creation
  creating_structure: "Creando su estructura",
  opening_chat: "Abriendo el chat",
  please_wait: "Por favor espere...",
  // ToDo page translations
  loading_todo: "Cargando ToDo...",
  task_updated: "Tarea actualizada",
  error_updating_task: "Error al actualizar tarea",
  task_deleted: "Tarea eliminada",
  error_deleting_task: "Error al eliminar tarea",
  delete_task_confirm: "¿Está seguro de que desea eliminar esta tarea?",
  description_label: "Descripción",
  description_placeholder: "Ingrese descripción...",
  date_time_label: "Fecha y hora",
  save_hint: "Ctrl+Enter para guardar, Esc para cancelar",
  edit_label: "Editar",
  delete_label: "Eliminar",
  todo_list_title: "Tareas",
  tasks_count: "tareas",
  search_placeholder_todo: "Buscar...",
  select_task_to_open_chat: "Seleccione una tarea para abrir el chat",
  today: "Hoy",
  yesterday: "Ayer",
  time_suffix: "", // Empty for Spanish (24h format doesn't need suffix)
  from_chat: "Tarea pendiente de origen",
  assigned_to: "Asignado a",
  assign_users: "Asignar usuarios",
  assigned_users: "Usuarios asignados:",
  no_users_assigned: "Sin usuarios asignados",
  assign: "Asignar",
  assign_to: "Asignar a...",
  navigate_to_chat: "Navegar al chat",
  navigate_to_email: "Ir al correo",
  show_original_message: "Mostrar origen",
  hide_original_message: "Ocultar origen",
  status_pending: "Pendiente",
  status_in_progress: "En progreso",
  status_completed: "Completado",
  show: "Mostrar",
  close: "Cerrar",
  // Additional ToDo translations
  todo_beta: "BETA",
  todo_project_label: "Proyecto:",
  todo_chat_label: "Chat:",
  todo_assigned_by: "Asignado por:",
  todo_assigned_push: "ToDo asignado:",
  todo_assigned_push_empty: "Se te ha asignado un nuevo ToDo.",
  todo_clear_all: "Limpiar todo",
  todo_unknown: "Desconocido",
  filter_all: "Todos",
  filter_assigned_to_me: "Mis tareas",
  filter_assigned_by_me: "Delegado",
  completed_by: "Completado por:",
  verify_completion: "Verificar",
  back_into_in_progress: "Volver en progreso",
  unassign_todo: "Desasignar tarea",
  unassign_label: "Desasignar",
  me: "Yo",
  search_or_select_project: "Buscar o seleccionar proyecto...",
  // Confirmed ToDo and History translations
  status_confirmed: "Confirmado",
  history: "Historial",
  marked_as: "Marcado como",
  at_date: "el",
  at_time: "a las",
  time_suffix: "",
  all_todos: "Tareas abiertas",
  confirmed_todos: "Tareas confirmadas",
  filter_pending: "Pendiente",
  filter_confirmed: "Confirmado",
  my_list: "Mi Día",
  todo_adjust_list: "Editar lista",
  apply: "Aplicar",
  move_back_in_progress: "Volver a en progreso",
  no_history_yet: "Sin historial aún",
  todo_status_updated: "Estado de la tarea actualizado de {from} a {to}",
  todo_status_updated_from: "de",
  todo_status_updated_to: "a",
  // Log description translations
  log_todo_created: "ToDo creado",
  log_todo_confirmed: "ToDo confirmado",
  log_todo_deleted: "ToDo eliminado",
  log_todo_updated: "ToDo actualizado",
  log_description_updated: "Descripción actualizada",
  log_deadline_updated: "Fecha límite actualizada",
  log_assigned_to: "Asignado a {name}",
  log_unassigned_from: "Desasignado de {name}",
  log_assignment_added: "Asignación añadida: {name}",
  log_assignment_removed: "Asignación eliminada: {name}",
  log_status_updated: "Estado cambiado de {from} a {to}",
  log_status_changed: "Estado cambiado",
  log_status_changed_to: "Estado cambiado a {status}",
  log_changed_status_to: "Estado cambiado a:",
  log_for_user: "para usuario:",
  log_user_updated_status: "Usuario actualizó el estado del ToDo",
  log_changed_date_to: "Fecha cambiada a:",
  log_changed_description_to: "Descripción cambiada a:",
  log_moved_to: "Movido a {status}",
  // ToDo filter translations
  todo_filters: "Filtros",
  todo_filter_by_project: "Filtrar por proyecto",
  todo_status: "Estado",
  todo_assignment: "Asignación",
  todo_filter_by_user: "Filtrar por persona asignada",
  todo_active_filters: "Filtros activos:",
  todo_progress: "Progreso",
  todo_my_list_empty: "Tu día está vacío",
  todo_my_list_empty_hint: "Haz clic en el botón de arriba para agregar tareas",
  create_poll: "Encuesta",
  poll_question_label: "PREGUNTA",
  poll_question_placeholder: "Haz una pregunta",
  poll_options_label: "OPCIONES",
  poll_option: "Opción",
  poll_add_option: "Añadir opción",
  poll_allow_multiple: "Permitir varias respuestas",
  poll_multiple_allowed: "Selecciona una o más opciones",
  poll_select_option: "Selecciona una opción",
  poll_view_votes: "Ver votos",
  poll_vote_singular: "voto",
  poll_vote_plural: "votos",
  poll_votes: "Votos de la encuesta",
  poll_no_votes_yet: "Aún no hay votos",
  transcript_step_processing: "Transcripción en curso...",
  ai_transcript_tab: "AI-Transcripción",
  ai_transcript_info: "Solo disponible para mensajes de voz creados después del 09.03.2026.",
  no_transcript_available: "No hay transcripción disponible.",
  transcript_more: "...más",
  transcript_less: "...menos",
  ki_transcript_voice_message: "KI-Transcripción del mensaje de voz",
  ki_image_analysis: "Análisis de imagen asistido por IA",
  type_message: "Escribe un mensaje",
  email_tab_messages: "Mensajes",
  email_tab_email: "Correo electrónico",
  email_tab_messages_and_email: "Messages & E-Mail",
  email_tab_email_details: "E-Mail Details",
  email_accounts: "Cuentas de correo",
  email_connect_gmail: "Conectar Gmail",
  email_connect_outlook: "Conectar Outlook",
  email_no_accounts: "Ninguna cuenta de correo conectada",
  email_no_accounts_hint: "Conecta una cuenta de correo en la configuración de tu perfil",
  email_no_messages: "Sin correos",
  email_from: "De",
  email_to: "Para",
  email_subject: "Asunto",
  email_disconnect: "Desconectar",
  email_disconnect_confirm: "¿Está seguro de que desea desconectar esta cuenta de correo? Todos los correos sincronizados se eliminarán.",
  email_account_disconnected: "Cuenta de correo desconectada con éxito",
  email_account_disconnect_failed: "Error al desconectar la cuenta",
  email_connecting: "Conectando...",
  email_account_connected: "Cuenta conectada correctamente",
  email_connected_accounts: "Cuentas conectadas",
  email_signature: "Firma",
  email_signature_placeholder: "Ingrese su firma de correo electrónico...",
  email_signature_save: "Guardar",
  email_signature_saved: "Guardado",
  email_add_account: "Añadir cuenta",
  email_folder_inbox: "Bandeja de entrada",
  email_folder_spam: "Spam",
  email_folder_drafts: "Borradores",
  email_folder_sent: "Elementos enviados",
  email_folder_deleted: "Elementos eliminados",
  email_folder_archive: "Archivo",
  email_folder_outbox: "Bandeja de salida",
  email_custom_folders: "Carpetas",
  email_create_folder: "Nueva carpeta",
  email_delete_folder: "Eliminar carpeta",
  email_folder_name_placeholder: "Nombre de la carpeta",
  email_folder_created: "Carpeta creada",
  email_folder_deleted: "Carpeta eliminada",
  email_move_to: "Mover a",
  email_moved_to_folder: "Movido a la carpeta",
  email_move_to_inbox: "Mover a bandeja de entrada",
  email_confirm_delete_folder: "¿Estás seguro de que quieres eliminar esta carpeta?",
  email_refresh: "Actualizar",
  email_go_to_settings: "Ir a configuración",
  email_date: "Fecha",
  email_reply: "Responder",
  email_forward: "Reenviar",
  email_copy_text: "Copiar texto",
  email_text_copied: "¡Copiado!",
  email_text_copy_failed: "No se pudo copiar el texto.",
  email_delete: "Eliminar",
  email_not_spam: "No es spam",
  email_not_spam_success: "Correo movido a la bandeja de entrada.",
  email_not_spam_failed: "Error al mover a la bandeja de entrada.",
  email_delete_confirm: "¿Estás seguro de que quieres eliminar este correo electrónico?",
  email_delete_from_folder: "¿Estás seguro de que quieres eliminar de {folder}?",
  email_delete_permanent_from_folder:
    "¿Estás seguro de que quieres eliminar permanentemente de {folder}? Esta acción no se puede deshacer.",
  email_save_draft_confirm: "¿Desea guardar este correo como borrador?",
  email_save_draft: "Guardar borrador",
  email_discard: "Descartar",
  email_back_to_compose: "Volver a redactar",
  email_draft_saved: "Borrador guardado.",
  email_draft_save_failed: "Error al guardar el borrador.",
  email_loading: "Cargando correos...",
  email_imap_title: "IMAP",
  email_imap_hint: "Conecta cualquier cuenta de correo por IMAP.",
  email_imap_user: "Correo electrónico",
  email_imap_password: "Contraseña",
  email_imap_connect_btn: "Conectar cuenta IMAP",
  email_imap_required: "Introduce correo y contraseña.",
  email_imap_failed: "Error de conexión IMAP.",
  email_imap_manual_toggle: "Configuración manual del servidor",
  email_imap_host: "Servidor IMAP (ej. imap.ionos.de)",
  email_imap_port: "Puerto",
  email_imap_incoming: "Correo entrante (IMAP)",
  email_smtp_outgoing: "Correo saliente (SMTP)",
  email_smtp_host: "Servidor SMTP (ej. smtp.ionos.de)",
  email_smtp_port: "Puerto",
  email_send_btn: "Enviar",
  email_sent: "Correo enviado.",
  email_send_failed: "Error al enviar el correo.",
  email_compose_to_required: "El destinatario (Para) es obligatorio.",
  email_compose_body_required: "Introduce un asunto o cuerpo del mensaje.",
  email_original_message: "Mensaje original",
  email_forwarded_message: "Mensaje reenviado",
  email_archived: "Archived",
  email_mark_spam: "Mark as spam",
  email_marked_spam: "Marked as spam",
  email_group_today: "Today",
  email_group_yesterday: "Yesterday",
  email_group_this_week: "This week",
  email_group_earlier: "Earlier",
  email_search: "Search",
  email_search_placeholder: "Search mail",
  email_no_results: "No matching messages",
  email_clear_search: "Clear search",
  email_star: "Star",
  email_unstar: "Unstar",
  email_starred: "Starred",
  email_folder_starred: "Starred",
  email_select: "Seleccionar",
  email_attachment_singular: "Adjunto",
  email_attachment_plural: "Adjuntos",
  email_back: "Atrás",
  email_download: "Descargar",
  email_close: "Cerrar",
  email_preview: "Vista previa",
  email_preview_not_available: "Vista previa no disponible",
  email_preview_failed: "Vista previa no disponible",
  select_attachments: "Seleccionar adjuntos",
  email_loading_preview: "Cargando vista previa...",
  email_mark_unread_failed: "correo(s) no se pudieron marcar como no leído(s).",
  email_delete_failed: "correo(s) no se pudieron eliminar.",
  filter_all: "Todos",
  filter_email: "E-Mail",
  filter_kjuup_messages: "Kjuup",
  filter_direct_messages: "Mensajes directos",
  my_notes: "My Space",
  filter_internal_groups: "Chats de grupo internos",
  filter_external_groups: "Chats de grupo externos",
  filter_group_chats: "Chats de grupo",
  filter_groups_internal: "Internos",
  filter_groups_external: "Externos",
  filter_unread_only: "Solo no leídos",
  room_daily_briefing_info: "Si está activado, se genera un informe de este proyecto cada 24 horas a la hora indicada en tu configuración personal — pero solo si ha habido actividad durante ese periodo.",
  email_select_all: "Seleccionar todo",
  email_deselect_all: "Deseleccionar todo",
  email_reply_all: "Responder a todos",
  email_reply_placeholder: "Escribe tu respuesta...",
  email_forward_placeholder: "Añade un mensaje...",
  email_edit_draft: "Editar borrador",
  email_attach: "Adjuntar",
  email_attachment_from_original: "Del mensaje original",
  email_remove: "Eliminar",
  email_drop_files: "Suelta los archivos para adjuntar",
  email_loading_attachments: "Cargando archivos adjuntos...",
  email_archive: "Archivar",
  mark_unread: "Marcar como no leído",
  mark_read: "Marcar como leído",
  email_all_accounts: "Todas las cuentas",
  email_error: "Error",
  email_delete_email_failed: "No se pudo eliminar el correo electrónico.",
  enter_url: "Ingrese URL",

  // ─── Kjuup subscription ───────────────────────────────────────────
  kjuup_io: 'Kjuup.io',
  kjuup_io_manage_subscription: 'Manage your subscription',
  kjuup_io_subscribe_now: 'Suscribirse ahora',
  kjuup_io_hero_subtitle: 'Upgrade to unlock premium features and get more out of every project.',
  kjuup_io_trial_badge: '1 MES DE PRUEBA GRATIS',
  kjuup_io_trial_title: 'Unlock Kjuup.io Premium',
  kjuup_io_trial_subtitle: 'Connect your email, receive AI-powered smart replies and synchronize your tasks with your calendar.',
  kjuup_io_trial_no_payment: 'No payment today.',
  kjuup_io_trial_trust: 'Sin pago hoy. No se solicitan datos de tarjeta de crédito antes de que comience la suscripción de pago.',
  kjuup_io_after_trial_monthly: 'After trial: {price}/month',
  kjuup_io_after_trial_yearly: 'After trial: {price}/year',
  kjuup_io_price_per_month: '{price}/month',
  kjuup_io_price_per_year: '{price}/year',
  kjuup_io_start_free_trial: 'Start free now � no risk',
  kjuup_io_trial_footnote: 'No payment today. Then {price}. Cancel anytime.',
  kjuup_io_feature_email: 'Gestiona todas las cuentas de correo directamente en Kjuup',
  kjuup_io_feature_assign: 'Automatically assign emails and attachments to projects',
  kjuup_io_feature_ai: 'La IA escribe las respuestas – tú solo confirmas',
  kjuup_io_feature_tasks: 'Tareas y calendario siempre actualizados automáticamente',
  kjuup_io_choose_plan: 'Elige tu plan',
  kjuup_io_plan_monthly: 'Mensual',
  kjuup_io_plan_yearly: 'Anual',
  kjuup_io_plan_monthly_desc: 'Billed monthly · cancel anytime',
  kjuup_io_plan_yearly_desc: 'Save {pct}% with annual booking',
  kjuup_io_save_badge: 'SAVE {pct}%',
  kjuup_io_per_month_annual: '{price} / month · Save {pct}% with annual booking',
  kjuup_io_subscribe: 'Subscribe',
  kjuup_io_secured_stripe: 'Protegido por Stripe · cancela cuando quieras',
  kjuup_io_your_subscription: 'YOUR SUBSCRIPTION',
  kjuup_io_status_active: 'ACTIVE',
  kjuup_io_status_cancels_soon: 'CANCELS SOON',
  kjuup_io_status_switch_scheduled: 'SWITCH SCHEDULED',
  kjuup_io_label_plan: 'Plan',
  kjuup_io_label_price: 'Price',
  kjuup_io_label_status: 'Status',
  kjuup_io_label_renews: 'Renews on',
  kjuup_io_label_access_until: 'Access until',
  kjuup_io_switching_to: 'Switching to {plan} on {date}',
  kjuup_io_cancel_pending_note: 'Your subscription is set to cancel and won\'t renew. You keep access until the date above.',
  kjuup_io_resume: 'Resume subscription',
  kjuup_io_switch_to_plan: 'Switch to {plan} plan',
  kjuup_io_undo_switch: 'Undo scheduled change',
  kjuup_io_cancel_subscription: 'Cancel subscription',
  kjuup_io_switch_modal_title: 'Switch to {plan} plan?',
  kjuup_io_billed_yearly: 'Billed yearly',
  kjuup_io_billed_monthly: 'Billed monthly',
  kjuup_io_switch_modal_note: 'Starts on {date}, when your current {plan} plan ends. No charge today — you keep your current plan until then.',
  kjuup_io_confirm_switch: 'Confirm switch',
  kjuup_io_not_now: 'Not now',
  kjuup_io_cancel_modal_title: 'Cancel subscription?',
  kjuup_io_cancel_modal_note: 'You\'ll keep access to Kjuup.io until the end of your current billing period. After that it won\'t renew.',
  kjuup_io_cancel_modal_note_with_date: 'You\'ll keep access to Kjuup.io until the end of your current billing period ({date}). After that it won\'t renew.',
  kjuup_io_cancel_plan: 'Cancel plan',
  kjuup_io_keep_subscription: 'Keep my subscription',
  kjuup_io_toast_payment_failed: 'Payment failed',
  kjuup_io_toast_activating: 'Pago recibido. Activando tu suscripción…',
  kjuup_io_toast_activating_soon: 'Pago recibido. Tu suscripción se activará en breve.',
  kjuup_io_toast_cancel_period: 'Your subscription will cancel at the end of the period',
  kjuup_io_toast_cancel_fail: 'Unable to cancel subscription',
  kjuup_io_toast_switch_scheduled: 'You\'ll move to the {plan} plan when your current period ends',
  kjuup_io_toast_switch_fail: 'Unable to switch plan',
  kjuup_io_toast_resumed: 'Your subscription will keep renewing',
  kjuup_io_toast_resume_fail: 'Unable to resume subscription',
  kjuup_io_toast_undo: 'Scheduled plan change canceled',
  kjuup_io_toast_undo_fail: 'Unable to cancel the scheduled change',
  kjuup_io_email_locked_body: 'Email is part of Kjuup.io. Activate a plan to use the Email tab.',
  kjuup_io_connect_email: 'Connect email with Kjuup.io',
  kjuup_io_activate_to_connect_email: 'Activate Kjuup.io to connect email accounts',

  kjuup_io_trial_no_card: 'No credit card details are requested before your paid subscription starts.',
  kjuup_io_status_trialing: 'TRIAL',
  kjuup_io_trial_days_left: '{days} days left in your free trial',
  kjuup_io_trial_left_hours: 'Quedan {count} horas',
  kjuup_io_trial_left_hour: 'Queda 1 hora',
  kjuup_io_trial_left_minutes: 'Quedan {count} minutos',
  kjuup_io_trial_left_minute: 'Queda 1 minuto',
  kjuup_io_trial_left_seconds: 'Quedan {count} segundos',
  kjuup_io_trial_left_second: 'Queda 1 segundo',
  kjuup_io_trial_ending_now: 'Tu prueba está terminando…',
  kjuup_io_request_timeout: 'Se agotó el tiempo de conexión. Inténtalo de nuevo.',
  kjuup_io_info_days_free: '{days} días completamente gratis – tu suscripción empieza solo después de la prueba.',
  kjuup_io_discount_total: 'Tu descuento: {percent} %',
  kjuup_io_discount_company: '{company}: {percent} %',
  kjuup_io_discount_personal: 'Personal: {percent} %',
  kjuup_io_trial_ends_tomorrow: 'Your free trial ends tomorrow',
  kjuup_io_trial_ends_today: 'Your free trial ends today',
  kjuup_io_banner_dismiss: 'Cerrar',
  kjuup_io_billing_after_trial: 'You\'ll be charged after your trial ends on {date}.',
  kjuup_io_trial_ended_title: 'Tu prueba gratuita ha terminado',
  kjuup_io_trial_ended_body: 'Suscríbete a Kjuup.io para seguir usando el correo electrónico y otras funciones premium.',
  kjuup_io_subscribe_to_continue: 'Subscribe now to continue',
  kjuup_io_trial_active_title: 'You\'re on a free trial',
  kjuup_io_trial_active_subtitle: 'Choose a plan and subscribe — billing starts when your trial ends.',
  kjuup_io_toast_trial_started: 'Tu prueba gratuita ha comenzado',
  kjuup_io_toast_trial_fail: 'No se pudo iniciar la prueba gratuita',
  kjuup_io_trial_try_month: 'Try Kjuup.io free for one month.',
  kjuup_io_per_month: 'per month',
  kjuup_io_price_month_line: '{price} / mes',
  kjuup_io_save_amount_year: 'Ahorra {price} al año',
  kjuup_io_billed_annually_amount: '{price} facturados anualmente',
  kjuup_io_save_yearly: 'Save {pct}% with yearly billing.',
  kjuup_io_savings_pct: '{pct}% savings',
  kjuup_io_features_title: 'Lo que obtienes:',
  kjuup_io_info_one_month_free: 'One month free',
  kjuup_io_info_plan_after_trial: 'Your selected subscription starts after the trial.',
  kjuup_io_info_cancel_trial: 'Cancel anytime during the trial.',
  kjuup_io_info_no_card: 'No se requiere tarjeta de crédito – empieza de inmediato, sin datos de pago.',
  kjuup_io_info_cancel_anytime: 'Cancela en cualquier momento – sin compromiso, sin riesgo.',
  kjuup_io_cta_plan_begins: 'Your selected plan begins after the free trial.',
  kjuup_io_billing_period_aria: 'Periodo de facturación',
  kjuup_io_subscription_info_title: 'Subscription information',
  kjuup_io_first_payment_on: 'First payment on {date}.',
  kjuup_io_renews_on: 'Renews on {date}.',
  kjuup_io_toast_card_saved: 'Método de pago guardado. El cobro se realizará al finalizar la prueba.',
  calendar_sync_info: 'Sincroniza automáticamente todos los ToDos de Kjuup con tu calendario.',
  calendar_no_accounts: 'Ningún calendario conectado.',
  article_new_badge: 'NUEVO',
  article_new_posts: '{0} publicaciones nuevas',
  documents: 'Documentos',
  add_documents: 'Añadir documentos',
  no_preview_available: 'Vista previa no disponible',
  no_preview_hint: 'Este tipo de archivo no se puede previsualizar, pero se enviará igualmente.',
  max_documents_reached: 'Puedes adjuntar hasta 10 documentos a la vez.',
  open_file: 'Abrir archivo',
  twofa_title: 'Autenticación en dos pasos',
  twofa_method_totp: 'App de autenticación',
  twofa_method_sms: 'SMS',
  twofa_method_email: 'Correo electrónico',
  twofa_enter_app: 'Introduce el código de 6 dígitos de tu app de autenticación.',
  twofa_enter_sms: 'Introduce el código de 6 dígitos que te enviamos por SMS.',
  twofa_enter_email: 'Introduce el código de 6 dígitos que te enviamos por correo.',
  twofa_resend: 'Reenviar código',
  twofa_try_another: 'Probar otro método',
  twofa_remember_device: 'No volver a preguntar en este dispositivo durante 30 días',
  twofa_sent: 'Hemos enviado un código.',
  twofa_invalid_code: 'Ese código es incorrecto. Inténtalo de nuevo.',
  twofa_something_wrong: 'Algo salió mal. Inténtalo de nuevo.',
  twofa_method_unavailable: 'Ese método no está disponible.',
  twofa_on_desc: 'La autenticación en dos pasos está activada. Necesitarás un código cada vez que inicies sesión.',
  twofa_off_desc: 'Añade un segundo paso después de tu contraseña. Las apps de autenticación son la opción más segura.',
  twofa_methods: 'Métodos',
  twofa_on: 'Activado',
  twofa_add: 'Añadir',
  twofa_default_method: 'Método predeterminado',
  twofa_default: 'Predeterminado',
  twofa_turn_off: 'Desactivar',
  twofa_disable_hint: 'Introduce tu contraseña y un código actual para desactivar la autenticación en dos pasos.',
  twofa_disable_need: 'Introduce tu contraseña y un código de verificación.',
  twofa_code_placeholder: 'Código de 6 dígitos o de respaldo',
  twofa_send_code: 'Enviar un código',
  twofa_primary_updated: 'El método predeterminado se ha actualizado.',
  twofa_disabled: 'La autenticación en dos pasos está desactivada.',
  twofa_enabled: 'La autenticación en dos pasos ya está activada.',
  twofa_totp_help: 'Escanea este código QR con Google Authenticator, Authy o 1Password. También puedes introducir la clave a mano.',
  twofa_secret_copied: 'Clave copiada',
  twofa_sms_help: 'Introduce tu número en formato internacional. Te enviaremos un código de 6 dígitos por SMS.',
  twofa_email_help: 'Enviaremos un código de 6 dígitos al correo de tu cuenta.',
  twofa_backup_title: 'Códigos de respaldo',
  twofa_backup_help: 'Guarda estos códigos de un solo uso en un lugar seguro. Cada uno sirve una vez si pierdes el teléfono.',
  twofa_copy_codes: 'Copiar códigos',
  twofa_codes_copied: 'Códigos de respaldo copiados',
  twofa_regenerate: 'Obtener nuevos códigos de respaldo',
  twofa_regenerate_hint: 'Esto sustituye los códigos de respaldo no usados. Introduce tu contraseña y un código actual.',
  twofa_backup_remaining: '{n} códigos de respaldo no usados restantes',
  twofa_new_codes: 'Nuevos códigos de respaldo',
  twofa_sms_unavailable: 'Los códigos por mensaje de texto aún no están disponibles.',
  todoist_sync_title: "Todoist",
  todoist_sync_info: "Las tareas de Kjuup que tienes asignadas se copian en un proyecto «Kjuup» de tu Todoist. Los cambios en Todoist no se copian de vuelta.",
  todoist_connect: "Conectar Todoist",
  todoist_connected: "Todoist conectado",
  todoist_connect_failed: "Error al conectar Todoist",
  todoist_disconnect: "Desconectar",
  todoist_disconnected: "Todoist desconectado",
  todoist_disconnect_confirm: "¿Desconectar Todoist? Las tareas que ya están en Todoist se quedan. La sincronización se detiene.",
  todoist_sync_now: "Sincronizar ahora",
  todoist_syncing: "Sincronizando…",
  todoist_sync_done: "Sincronización terminada",
  todoist_sync_failed: "Error de sincronización",
  todoist_auth_error: "Vuelve a conectar Todoist para seguir sincronizando.",
  todoist_last_sync: "Última sincronización",
  todoist_not_connected: "Todoist no está conectado",
  todoist_auth_url_failed: "No se pudo abrir la página de autorización de Todoist.",
  recommend_text: "Únete a Kjuup para mantenerte conectado y tener tu comunicación organizada. Reúne tus canales, mantén los mensajes en los proyectos correctos y empieza cada mañana con un resumen y tus tareas, todo sincronizado con las apps que ya usas. Empieza gratis:",
  pro_auth_signin_title: 'Bienvenido de nuevo',
  pro_auth_signin_sub: 'Inicie sesión con su correo electrónico de trabajo.',
  pro_auth_email_or_username: 'Correo electrónico o nombre de usuario',
  pro_auth_email_placeholder: 'nombre@empresa.es',
  pro_auth_forgot_password: '¿Olvidó su contraseña?',
  pro_auth_create_account: 'Crear cuenta',
  pro_auth_show_password: 'Mostrar contraseña',
  pro_auth_hide_password: 'Ocultar contraseña',
  pro_auth_register_sub: 'Le enviaremos un enlace para confirmar su correo electrónico.',
  pro_auth_register_plus_sub: 'Elija un nombre de usuario y una contraseña. A continuación establecerá su PIN de seguridad.',
  pro_auth_check_credentials: 'Compruebe su correo electrónico y contraseña',
  pro_news_export_pdf: 'Exportar como PDF',
  pro_news_pdf_failed: 'No se pudo crear el PDF.',
  pro_news_pdf_attachments: 'Adjuntos',
  pro_news_pdf_video: 'Vídeo',
  pro_auth_forgot_sub: 'Introduzca su correo electrónico y le enviaremos un enlace para restablecer su contraseña.',
  pro_auth_send_link: 'Enviar enlace de restablecimiento',
  pro_auth_plus_reset: 'Restablecer con PIN',
  pro_auth_show_pin: 'Mostrar PIN',
  pro_auth_hide_pin: 'Ocultar PIN',
  v2_auth_plus_only: 'Solo Kjuup+',
  room_action_media: "Archivos",
  room_tab_overview: "Resumen",
  room_tab_history: "Historial",
  chat_info_media: "Archivos",
  messages: "mensajes",
  pro_todo_project_required: "Elige un proyecto",
  pro_todo_choose_project: "¿Para qué proyecto es esta tarea?",
  cockpit_report_delete_confirm: "¿Eliminar este informe diario?",
  cockpit_report_deleted: "Informe diario eliminado",
  cockpit_tab_company: "Empresa",
  cockpit_bookmarked_priorities: "Tareas guardadas",
  cockpit_load_error: "No se pudo cargar el cockpit.",
  cockpit_retry: "Reintentar",
  cockpit_yesterday: "Ayer",
  cockpit_greeting_morning: "Buenos días",
  cockpit_greeting_day: "Buenas tardes",
  cockpit_greeting_evening: "Buenas noches",
  cockpit_assistant_q_open: "¿Qué hay pendiente hoy?",
  cockpit_assistant_q_summarize: "Resume el chat {{room}}",
  cockpit_assistant_q_overdue: "¿Qué tareas están vencidas?",
  cockpit_assistant_new: "{{n}} nuevos",
  cockpit_assistant_important: "{{n}} importantes",
  cockpit_assistant_title: "Asistente Kjuup",
  cockpit_assistant_hint: "Toque y pregunte",
  room_overview_priority_no_detail: "El informe no ofrece más detalles sobre esta prioridad.",
  room_overview_priority_from: "Fuente: {{name}}",
  room_overview_priority_open_task: "Abrir tarea",
  cockpit_priority_position: "{{index}} de {{total}} prioridades",
  room_overview_today_title: "Importante hoy",
  room_overview_all_tasks: "Todas",
  room_overview_tasks_empty: "No hay plazos ni tareas abiertos",
  room_overview_appointments_empty: "No hay citas próximas",
  room_overview_no_priorities: "No hay prioridades abiertas en el último informe.",
  cockpit_report_top5: "Las 5 prioridades principales",
  cockpit_report_todo_created: "Tarea creada",
  cockpit_report_source_missing: "No se encontró el mensaje de origen.",
  delete_bookmarked_priority_confirm: "¿Seguro que desea eliminar esta tarea guardada?",
  cockpit_report_create_todo: "Crear tarea",
  cockpit_priorities_deleting: "Eliminando …",
  cockpit_priorities_select: "Eliminar varias",
  cockpit_report_none: "Sin entradas.",
  cockpit_priorities_delete_confirm: "¿Seguro que desea eliminar {count} tareas guardadas?",
  cockpit_priorities_delete_failed: "No se pudieron eliminar {count} tareas",
  cockpit_priorities_deleted: "{count} tareas eliminadas",
  cockpit_priorities_selected: "{count} seleccionadas",
  cockpit_channel_connected: "Conectado",
  cockpit_channel_not_connected: "No conectado",
  cockpit_channel_connect: "Conectar",
  cockpit_channel_chat: "Chat de Kjuup",
  cockpit_channel_active: "Activo",
  cockpit_channel_hidden: "Oculto",
  cockpit_channel_enable: "Activar",
  cockpit_channel_email: "Correo electrónico",
  cockpit_channel_check: "Comprobar conexión",
  cockpit_channel_fix: "Comprobar",
  cockpit_channel_forward: "Dirección de reenvío",
  cockpit_channel_not_set_up: "No configurado",
  cockpit_channel_set_up: "Configurar",
  cockpit_channel_teams: "Microsoft Teams",
  cockpit_channel_broken: "Conexión perdida",
  cockpit_channel_importing: "Importando",
  cockpit_channel_removing: "Desconectando",
  cockpit_channel_reconnect: "Reconectar",
  cockpit_channels_title: "Canales",
  cockpit_company_role_super_admin: "Admin de la empresa",
  cockpit_company_role_dept_admin: "Admin de departamento",
  cockpit_company_role_member: "Empleado",
  cockpit_company_none: "No se encontró ninguna empresa Kjuup+",
  cockpit_company_eyebrow: "Empresa",
  cockpit_company_inactive: "inactiva",
  cockpit_company_settings: "Ajustes de la empresa",
  cockpit_company_employees: "Empleados",
  cockpit_company_internal_rooms: "Proyectos internos",
  cockpit_report_all_projects: "Todos los proyectos",
  cockpit_report_progress_emails: "Analizando correos electrónicos",
  cockpit_report_progress_chats: "Analizando mensajes de chat",
  cockpit_report_progress_documents: "Analizando adjuntos y documentos",
  cockpit_report_progress_tasks: "Analizando tareas",
  cockpit_report_progress_summarizing: "Analizando contenido",
  cockpit_report_progress_reading: "Reutilizando contenido ya analizado",
  cockpit_report_progress_collecting: "Recopilando correos, chats y tareas de sus proyectos",
  cockpit_report_progress_priorities: "Reuniendo prioridades, plazos y decisiones",
  cockpit_report_progress_queued: "Preparando el informe",
  cockpit_report_creating_title: "Su informe diario se está preparando",
  cockpit_report_progress_count_one: "1 elemento analizado",
  cockpit_report_progress_count_many: "{{count}} elementos analizados",
  cockpit_report_progress_hint: "Suele tardar uno o dos minutos; mientras tanto puede seguir usando el cockpit.",
  cockpit_report_time_hint: "El informe diario se crea cada día a las {{hour}}:00 para los cinco proyectos más activos.",
  room_overview_priorities_title: "Estado actual y prioridades",
  room_overview_as_of: "Actualizado a {{time}}",
  cockpit_report_delete: "Eliminar informe diario",
  email_tag_daily_briefing: "Informe diario",
  cockpit_report_unread: "Nuevo",
  cockpit_report_clear_project: "Mostrar todos los proyectos",
  cockpit_filter_project: "Proyecto",
  cockpit_filter_all_projects: "Todos los proyectos",
  cockpit_report_recreate: "Volver a crear informe diario",
  cockpit_report_hide_previous: "Ocultar informes diarios anteriores",
  cockpit_report_show_previous: "Mostrar informes diarios anteriores",
  cockpit_report_room_empty: "Aún no hay informe diario para este proyecto",
  cockpit_report_empty: "Aún no hay informe diario",
  cockpit_report_room_empty_hint: "Cree un informe diario solo para este proyecto.",
  cockpit_report_needs_mailbox: "Conecte una cuenta de correo para que Kjuup pueda crear un informe diario con tareas automáticas.",
  cockpit_report_create: "Crear informe diario",
  cockpit_email_connect: "Conectar correo",
  cockpit_email_none_title: "Aún no hay ninguna cuenta de correo conectada",
  cockpit_email_none_reports: "Conecte su buzón para que Kjuup pueda asignar los correos entrantes a sus proyectos y crear informes diarios con tareas.",
  cockpit_email_none_client: "Conecte Gmail, Outlook o IMAP para leer, asignar y responder correos directamente en Kjuup.io.",
  cockpit_email_reports_title: "Cliente de correo actual",
  cockpit_email_reports_text: "Sin bandeja de entrada en Kjuup.io · {{rooms}} proyectos con informe diario a las {{hour}}:00 · los correos entrantes se asignan a sus proyectos.",
  cockpit_email_reports_rooms: "Gestionar proyectos",
  cockpit_email_settings: "Ajustes de correo",
  cockpit_email_error_title: "Comprobar conexión",
  cockpit_email_client_title: "Bandeja de entrada conectada",
  cockpit_email_accounts_n: "{{n}} cuenta conectada",
  cockpit_email_last_sync: "última sincronización {{when}}",
  cockpit_email_report_at: "Informe diario a las {{hour}}:00",
  cockpit_email_open_inbox: "Abrir bandeja de entrada",
  cockpit_email_eyebrow: "Kjuup-Correo",
  cockpit_email_accounts_label: "Direcciones de correo conectadas",
  email_no_subject: "(Sin asunto)",
  cockpit_email_detail_loading: "Cargando correo …",
  cockpit_email_detail_failed: "No se pudo cargar el correo.",
  cockpit_email_detail_empty: "Este correo no tiene texto.",
  cockpit_personal_settings: "Ajustes personales",
  cockpit_companies: "Empresas",
  cockpit_title: "Cockpit",
  cockpit_back: "Volver al resumen",
  cockpit_day_overview: "Su día de un vistazo",
  email_saved_to_project: "Correo guardado en el proyecto",
  email_classify_need_project: "Introduzca un nombre de proyecto",
  cockpit_email_deleted: "Correo eliminado",
  cockpit_email_sent_empty: "Aún no hay correos enviados.",
  cockpit_email_incoming_empty: "Aún no hay correos recibidos.",
  cockpit_email_incoming_title: "Correos",
  cockpit_email_incoming_sub: "Asigne los correos recibidos y enviados a sus proyectos. Aquí puede ajustar la asignación.",
  cockpit_email_incoming_unassigned_n: "{{n}} sin asignar",
  cockpit_email_folder_inbox: "Bandeja de entrada",
  cockpit_email_folder_sent: "Enviados",
  cockpit_email_open: "Abrir correo",
  cockpit_email_incoming_suggested: "Sugerido: {{room}}",
  cockpit_email_incoming_apply: "Aplicar",
  cockpit_email_incoming_adjust: "Ajustar asignación",
  cockpit_email_incoming_saving: "Guardando …",
  cockpit_email_incoming_unassigned: "Sin asignar",
  cockpit_email_incoming_show_less: "Mostrar menos",
  cockpit_email_incoming_show_all: "Mostrar todos ({{n}})",
  cockpit_io_settings: "Ajustes de Kjuup.io",
  cockpit_io_settings_sub: "Plan y puestos, asignación de empleados, facturación y facturas.",
  products_coming_soon: "Próximamente",
  cockpit_upsell_io_title: "Su oficina que piensa por usted",
  cockpit_upsell_io_text: "Conecte sus cuentas de correo con Kjuup. Los correos, adjuntos y mensajes se guardan automáticamente en el proyecto correspondiente y, opcionalmente, pueden almacenarse en su servidor. Cada día recibe un resumen de todos los proyectos con los puntos clave de todos los contenidos, y sus tareas se sincronizan con su calendario o app de tareas.",
  cockpit_upsell_io_soon_title: "Aún no disponible para contratar",
  cockpit_upsell_io_soon_text: "Kjuup.io se lanzará pronto. Solicite información ahora; le avisaremos en cuanto pueda contratar Kjuup.io.",
  cockpit_upsell_io_planned_price: "Precio previsto",
  cockpit_upsell_io_cta_request: "Solicitar información",
  kjuup_plus_abo_per_year: "/ año",
  kjuup_plus_abo_per_month: "/ mes",
  kjuup_plus_abo_status_active: "Activo",
  kjuup_plus_abo_status_requested: "Cancelación solicitada",
  kjuup_plus_abo_status_past_due: "Pago pendiente",
  kjuup_plus_abo_eyebrow: "Kjuup+ · Suscripción",
  kjuup_plus_abo_title: "Paquete Kjuup+",
  kjuup_plus_abo_seats_free_one: "1 puesto libre",
  kjuup_plus_abo_billing: "Facturación",
  kjuup_plus_abo_yearly: "Anual",
  kjuup_plus_abo_monthly: "Mensual",
  kjuup_plus_abo_amount: "Importe",
  kjuup_plus_abo_ends: "Finaliza el",
  kjuup_plus_abo_renews: "Próxima renovación",
  kjuup_plus_abo_next_invoice: "Próxima factura",
  kjuup_plus_abo_intro: "Precio de lanzamiento",
  kjuup_plus_abo_pending_tier: "Desde la próxima renovación",
  kjuup_plus_abo_manual: "Kjuup+ está activo para su empresa mediante un acuerdo individual.",
  kjuup_plus_abo_invoices: "Facturas",
  kjuup_plus_abo_invoice_paid: "Pagada",
  kjuup_plus_abo_invoice_view: "Ver",
  kjuup_plus_abo_invoices_less: "Mostrar menos",
  kjuup_plus_abo_member_hint: "La facturación y la cancelación las gestionan los administradores de su empresa.",
  kjuup_plus_abo_withdraw: "Retirar solicitud",
  kjuup_plus_abo_cancel_note: "Motivo (opcional)",
  kjuup_plus_abo_cancel_send: "Solicitar cancelación",
  kjuup_plus_abo_cancel: "Cancelar suscripción",
  cockpit_upsell_plus_f1: "Gestione la actividad de comunicación de todos sus empleados",
  cockpit_upsell_plus_f2: "Informe a grupos de usuarios concretos dentro de la empresa",
  cockpit_upsell_plus_f3: "Guarde los chats de grupo internos",
  cockpit_upsell_plus_when_yearly: "con pago anual",
  cockpit_upsell_plus_size_small: "1–50 empleados",
  cockpit_upsell_plus_size_large: "51–200 empleados",
  cockpit_upsell_plus_title: "Kjuup+ para empresas",
  cockpit_upsell_plus_text: "Gestione empleados, permisos de escritura y comunicación de la empresa en un solo lugar. Los canales internos se quedan en su equipo, los canales externos le conectan con socios de proyecto y puede llegar directamente a grupos concretos. Además de Kjuup+, puede contratar el acceso a Kjuup.io para grupos de empleados. Kjuup+ y Kjuup.io se pueden combinar.",
  cockpit_upsell_plus_size: "Tamaño de la empresa",
  cockpit_upsell_plus_billing: "Facturación",
  cockpit_upsell_plus_per_company: "/ empresa · mes sin IVA",
  cockpit_upsell_plus_onboarding: "Los costes de incorporación/puesta en marcha dependen del tamaño de la empresa",
  cockpit_upsell_plus_larger: "Precios para empresas más grandes bajo petición",
  cockpit_upsell_plus_cta: "Consulta sin compromiso",
  cockpit_kpi_deadlines_tasks: "Plazos y tareas",
  cockpit_kpi_appointments: "Citas",
  cockpit_room_admin: "Gestión de proyectos y chats",
  cockpit_room_admin_sub: "Todos los proyectos de la empresa con miembros, archivos multimedia y chats.",
  pro_todo_not_found: "Esta tarea ya no está disponible.",
  cockpit_chip_overdue: "Vencida",
  cockpit_chip_today: "Hoy",
  cockpit_calendar_week: "Sem. {{week}}",
  cockpit_prev_week: "Semana anterior",
  cockpit_next_week: "Semana siguiente",
  cockpit_chip_requested: "Solicitada",
  cockpit_todo_due: "Plazo {{when}}",
  cockpit_todo_at: "{{time}}",
  cockpit_todo_requested_from: "de {{name}}",
  cockpit_todo_since: "desde {{when}}",
  cockpit_todo_no_date: "Sin fecha",
  cockpit_todo_mark_done: "Marcar como completada",
  cockpit_my_tasks_title: "Mis tareas",
  cockpit_today_tasks_group: "Tareas de hoy",
  cockpit_assign_none: "Nadie asignado",
  no_project_found: "No se encontró ningún proyecto",
  cockpit_row_more_actions: "Más acciones",
  needs_date: "Asignar fecha",
  cockpit_assign_proposal: "{{name}} reconocido: ¿asignar?",
  cockpit_assign_proposal_confirm: "Asignar",
  cockpit_assign_proposal_dismiss: "Ignorar",
  cockpit_priority_date: "Fecha",
  todo_calendar_add: "Añadir al calendario",
  todo_calendar_remove: "Quitar del calendario",
  cockpit_todo_change_project: "Cambiar de proyecto",
  cockpit_todo_set_date: "Definir fecha",
  pro_todo_done_confirm: "¿Seguro que desea marcar esta tarea como completada?",
  cockpit_task_delete_failed: "No se pudo eliminar la tarea.",
  cockpit_setup_title: "Terminar la configuración",
  cockpit_setup_text: "Decida si quiere usar chats y si Kjuup.io debe funcionar como cliente de correo o solo con proyectos e informes diarios.",
  cockpit_setup_cta: "Configurar ahora",
  cockpit_group_tasks: "Plazos y tareas",
  cockpit_group_appointments: "Citas",
  cockpit_report_no_activity: "Este proyecto no ha tenido mensajes ni correos nuevos en las últimas 24 horas.",
  cockpit_report_room_unavailable: "Este proyecto no está disponible.",
  cockpit_report_create_failed: "No se pudo crear el informe diario.",
  cockpit_report_created: "Informe diario creado",
  addon_enable_confirm: "¿Activar el complemento?",
  addon_enable: "Activar",
  addon_enabled: "Complemento activado",
  nav_email: "Correo",
  nav_my_cockpit: "Mi cockpit",
  nav_news: "Novedades",
  nav_recommend: "Recomendar",
  pro_todo_status_done: "Completada",
  pro_todo_status_open: "Abierta",
  v2_todo_remove: "Quitar",
  pro_todo_search_people: "Buscar personas",
  pro_todo_clear: "Borrar",
  pro_todo_assigned: "(asignado)",
  pro_todo_no_people: "No se encontraron personas",
  pro_todo_search_rooms: "Buscar proyectos",
  pro_todo_no_rooms_match: "Ningún proyecto coincide con «{{q}}»",
  pro_todo_no_rooms: "No se encontraron proyectos",
  pro_todo_activity: "Actividad",
  pro_todo_show_less: "Mostrar menos",
  pro_todo_show_all: "Mostrar todo ({{n}})",
  pro_todo_due: "Plazo",
  pro_todo_room: "Proyecto",
  pro_todo_select_room: "Seleccionar proyecto",
  pro_todo_status: "Estado",
  pro_todo_more: "Más",
  pro_todo_edit_title: "Editar tarea",
  pro_todo_description: "Descripción",
  pro_todo_created_by: "Creada por",
  pro_todo_chat: "Chat",
  navigate_to_source: "Ir al origen",
  todo_calendar_connect_title: "Ningún calendario conectado",
  todo_calendar_connect_body_web: "Conecte un calendario en los ajustes de sincronización del calendario para añadir tareas.",
  todo_calendar_connect: "Conectar",
  todo_calendar_removed: "Quitado de su calendario",
  todo_calendar_added_later: "Añadido. No se pudo acceder a su calendario; Kjuup lo intentará de nuevo más tarde.",
  todo_calendar_added: "Añadido a su calendario",
  todo_calendar_no_date: "Solo una tarea con fecha se puede añadir a un calendario.",
  todo_calendar_failed: "No se pudo actualizar su calendario. Inténtelo de nuevo.",
  todo_calendar_date_title: "Aún sin fecha",
  todo_calendar_date_save: "Definir fecha y añadir",
  todo_calendar_date_body_web: "Esta tarea guardada aún no tiene fecha. Defina una para añadirla a su calendario.",
  kjuup_io_setup_saved: "Configuración guardada",
  kjuup_io_setup_step: "Paso",
  kjuup_io_setup_chats_title: "¿Quiere usar chats?",
  kjuup_io_setup_email_title: "¿Dónde quiere leer sus correos?",
  kjuup_io_setup_chats_sub: "Los chats con compañeros y socios de proyecto son opcionales. Puede mostrarlos u ocultarlos en el cockpit en cualquier momento.",
  kjuup_io_setup_email_sub: "Aquí solo elige si usa un cliente de correo en Kjuup o sigue con su programa de correo actual, como Outlook u otro. Podrá cambiarlo más tarde.",
  kjuup_io_setup_chats_yes: "Sí, mostrar chats",
  kjuup_io_setup_chats_yes_text: "Mensajes incluye chats y correos. Los proyectos tienen chats de grupo para todos los participantes.",
  kjuup_io_setup_chats_no: "No, trabajar sin chats",
  kjuup_io_setup_chats_no_text: "Los chats se ocultan. «Mensajes» pasa a ser «Correo»; los proyectos, tareas e informes diarios se mantienen.",
  kjuup_io_setup_email_client: "Cliente de correo en Kjuup",
  kjuup_io_setup_email_client_text: "Lea y responda correos directamente en Kjuup.",
  kjuup_io_setup_email_reports: "Cliente de correo actual",
  kjuup_io_setup_email_reports_text: "Siga leyendo y respondiendo en su programa actual, como Outlook u otro.",
  kjuup_io_setup_skip: "Más tarde",
  next: "Siguiente",
  kjuup_io_setup_finish: "Terminar la configuración",
  today_label: "hoy",
  tomorrow_label: "mañana",
  cockpit_todo_overdue: "vencida",
  cockpit_report_management_fazit: "Resumen de gestión",
  cockpit_todo_appointment: "Cita",
  cockpit_todo_deadline: "Plazo",
  cockpit_todo_deadline_define: "Definir plazo",
  pro_todo_status_acknowledged: "Confirmada",
  pro_todo_responsible: "Responsable",
  pro_todo_notice_confirmed: "Confirmado en el chat",
  pro_todo_notice_sent_at: "Mensaje enviado",
  pro_todo_notice_again: "Volver a enviar el mensaje",
  pro_todo_notice_send: "Informar mediante mensaje de Kjuup",
  pro_todo_add_assignee: "Añadir",
  pro_todo_edit: "Editar",
  pro_todo_change_room: "Cambiar de proyecto",
  pro_todo_due_on: "Plazo hasta el",
  pro_todo_edit_due: "Editar plazo",
  pro_todo_no_date: "Sin fecha",
  pro_todo_edit_description: "Editar descripción",
  pro_todo_no_description: "Aún sin descripción",
  pro_todo_title_label: "Título",
  pro_todo_title_placeholder: "Introduce un título...",
  pro_todo_task: "Tarea",
  pro_todo_what: "¿Qué hay que hacer?",
  pro_todo_source_email: "Correo",
  pro_todo_sources: "Fuentes",
  previous: "Anterior",
  kjuup_plus_abo_tier_large: "Kjuup+ Large (hasta {max} empleados)",
  kjuup_plus_abo_tier_small: "Kjuup+ Small (hasta {max} empleados)",
  kjuup_plus_abo_status_ends: "Finaliza el {date}",
  kjuup_plus_abo_seats_over: "Más de {max} empleados – Kjuup se pondrá en contacto contigo con una oferta personalizada.",
  kjuup_plus_abo_seats_next: "Si se incorporan más empleados, el paquete cambia automáticamente a {next} (de forma prorrateada).",
  kjuup_plus_abo_seats_used: "{used} de {total} puestos ocupados",
  kjuup_plus_abo_seats_free: "Quedan {count} puestos libres",
  kjuup_plus_abo_intro_until: "hasta el {date}",
  kjuup_plus_abo_invoice_open: "Pendiente · vence el {date}",
  kjuup_plus_abo_invoices_all: "Mostrar todas ({count})",
  kjuup_plus_abo_requested_hint: "Cancelación solicitada el {date}. Kjuup la confirmará al final del periodo contratado ({end}).",
  kjuup_plus_abo_cancel_hint: "Kjuup revisa tu solicitud y confirma la cancelación al final del periodo contratado ({end}). Hasta entonces, Kjuup+ sigue activo.",
  kjuup_plus_abo_withdrawn: "Solicitud de cancelación retirada",
  kjuup_plus_abo_requested: "Cancelación solicitada",
  cockpit_upsell_plus_intro_hint: "los primeros {months} meses, luego {price}",
  cockpit_upsell_plus_badge: "PRECIO DE LANZAMIENTO DURANTE {months} MESES",
  calendar_syncing: "Actualizando desde el calendario…",
  calendar_sync_up_to_date: "El calendario está al día",
  calendar_sync_failed: "Error de sincronización",
  delete_multiple_tasks_confirm: "¿Estás seguro de que quieres eliminar {count} ToDos?",
  todos_deleted_count: "{count} ToDos eliminados",
  todos_deleted_partial: "{ok} ToDos eliminados, {fail} con error",
  todo_created_from_message: "Tarea creada a partir de este mensaje",
  kjuup_io_todo_calendar_trial_ended_note: "Sincronización de calendario · Suscribirse",
  kjuup_io_todo_calendar_nudge: "¿Sincronizar este ToDo con su calendario?",
  kjuup_io_todo_calendar_nudge_cta: "Activar Kjuup.io",
  todo_confirmed: "ToDo confirmado",
  pro_todo_bulk_delete_title: "¿Eliminar {{n}} tareas?",
  pro_todo_previous_none_own: "Las tareas vencidas te las asignaron otras personas y solo ellas pueden eliminarlas.",
  pro_todo_previous_none: "No hay tareas vencidas",
  pro_todo_previous_title: "¿Eliminar {{n}} tareas vencidas?",
  pro_todo_previous_text: "Se eliminarán todas tus tareas abiertas de días anteriores.",
  pro_todo_previous_skipped: "Se mantienen {{n}} asignadas por otras personas.",
  unassign_task_confirm: "¿Desea desasignarse de esta tarea?",
  pro_todo_delete_title: "Eliminar tarea",
  pro_todo_today: "Hoy",
  pro_todo_yesterday: "Ayer",
  pro_todo_since_yesterday: "Desde ayer",
  pro_todo_mark_open: "Marcar como abierta",
  new_label: "Nuevo",
  bookmarked_no_mylist: "Las tareas marcadas no se pueden añadir a Mi lista",
  delete_only_own: "Solo puedes eliminar las tareas que creaste tú",
  pro_todo_of_completed: "{{done}} de {{total}} completadas",
  pro_todo_pick_date: "Elegir una fecha",
  pro_todo_show_day: "Mostrar día",
  pro_todo_section_upcoming: "Próximas",
  pro_todo_section_done: "Hechas",
  pro_todo_room_empty_today: "No hay tareas para hoy en este proyecto",
  pro_todo_room_empty_day: "No hay tareas este día en este proyecto",
  pro_todo_delete_previous: "Eliminar todas",
  pro_todo_empty_title: "Nada por aquí",
  pro_todo_empty_hint: "Ninguna tarea coincide con esta vista.",
  pro_todo_selected: "{{n}} seleccionadas",
  delete_selected_count: "Eliminar ({count})",
  pro_todo_adjust_done: "Listo",
  pro_todo_deleting: "Eliminando...",
  pro_todo_reopen: "Reabrir tarea",
  pro_todo_step_done: "Completada",
  pro_todo_mark_not_started: "Marcar como no iniciada",
  pro_todo_mark_in_progress: "Marcar como en curso",
  pro_todo_open_room: "Abrir proyecto",
  pro_todo_new_task: "Nueva tarea",
  select_user_back_to_in_progress: "Selecciona el usuario que vuelve a en progreso",
  cockpit_email_accounts_n_many: "{{n}} cuentas conectadas",
  // Kjuup + Microsoft Teams chats (new-chat pickers, combined groups)
  combined_tab_kjuup: "Contactos de Kjuup",
  combined_tab_teams: "Contactos de Teams",
  combined_bridge_failed: "No se pudo crear la copia de Teams.",
  combined_chat_label: "Kjuup + Teams",
  combined_guest_tag: "Teams",
  combined_new_group_note: "Contactos de Kjuup y Teams: se crea un grupo nuevo que también aparece en Microsoft Teams.",
  teams_new_chat_title: "Nuevo chat de Teams",
  teams_new_chat_topic: "Nombre del grupo (opcional)",
  teams_new_chat_start: "Iniciar chat",
  teams_new_chat_creating: "Creando chat…",
  teams_new_chat_forbidden: "Microsoft Teams no permite este chat (p. ej., una persona fuera de tu organización o una política de tu departamento de TI).",
  teams_new_chat_too_many: "Demasiadas personas para un chat.",
  teams_new_chat_type_hint: "Escribe un nombre para buscar en tu organización.",
  teams_new_chat_directory_forbidden: "Tu organización no permite buscar en el directorio. Solo se muestran personas de tus chats de Teams.",
  teams_new_chat_account: "Cuenta",
};
